import React, { useEffect, useState } from "react";
import { Spin, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { store } from "../../../redux/configStore";
import { getByIdGiftExchange } from "../../../api/giftExchange/giftExchange";
import EditGiftExchangeTable from "./EditGiftExchangeTable";

export default function EditGiftExchangePage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);

  const back = () => navigate("/gift-exchanges");

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await store.dispatch(getByIdGiftExchange({ id }));
        if (cancelled) return;
        const data = res.payload?.data || res.payload;
        if (!data || !data.id) {
          message.error("Không tìm thấy chương trình quà tặng");
          back();
          return;
        }
        setRecord(data);
      } catch (e) {
        message.error("Lỗi tải dữ liệu");
        back();
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    if (id) load();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "70vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!record) return null;

  return (
    <EditGiftExchangeTable
      asPage
      isModalOpen={true}
      currentPage={1}
      pageSize={10}
      handleOk={back}
      handleCancel={back}
      record={record}
    />
  );
}
